// ============================================================================
// File: components/charts/SpendTrendChart.jsx
// Purpose:
//   Monthly Procurement Spend Trend (Chart Only — No Header)
// ============================================================================

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid
} from "recharts";

export default function SpendTrendChart({ data }) {

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
        />

        <YAxis
          tickFormatter={(v) => `₹${(v/100000).toFixed(1)}L`}
          tick={{ fontSize: 12 }}
        />

        <Tooltip
          formatter={(value) =>
            `₹ ${Number(value).toLocaleString()}`
          }
        />

        <Line
          type="monotone"
          dataKey="amount"
          stroke="#4f7cff"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />

      </LineChart>
    </ResponsiveContainer>
  );
}
